import { useQuery } from 'hooks'
import { useMemo } from 'react'


type Announcement = {
  title: string
  text: string
  url: string
  comment: string
  urlText: string
}

type AnnouncementApiData = {
  topAnnouncement: Announcement
  hash: string
}

const useAnnouncement = (skip?: boolean) => {
  const options = useMemo(() => ({
    url: '/ajax.php?action=getAnnouncements',
    modifyResult: ({ url, ...data }) => ({
      ...data,
      toTab: url,
    }),
    skip,
  }), [ skip ])

  const { data, isFetching: isAnnouncementFetching, errors } = useQuery<AnnouncementApiData>(options)
  const { topAnnouncement: announcement, hash } = data || {}

  return { announcement, hash, isAnnouncementFetching }
}

export default useAnnouncement